import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { theme } from '../../themes/theme.js'
import axios from '../../dataClient/dataClient'
import { getFile, downloadZipFile } from '../../util/downloadFile.js'
import { FlexEndButtonErrorContainer, FlexColumn } from '../styles/Containers.js'
import { ErrorMessage } from '../common/UserMessage.js'
import { downloadFileListTypeMap } from '../../util/consts.js'
import pirTerminology from '../../util/pirTerminology'
import BodyText from '../styles/Text.js'
import Button from '../common/Button.js'
import FileList from './FileList.js'

const FileListContainer = styled.div`
  background: ${theme.colors.background.medium};
  border-radius: ${theme.borderRadius.div};
  padding: 20px 30px 5px 15px;
`

function DownloadFileList({ type = 'pir', fileList = [], requestId, secondaryId }) {
  const [downloadError, setDownloadError] = useState(false)
  async function downloadAll() {
    setDownloadError(false)
    const files = []
    let fileError = false

    for (const f of fileList) {
      const filename = type === 'pir' ? f.name : f.filename
      try {
        const response =
          type === 'pir'
            ? await axios.get(`/download/${requestId}/${encodeURIComponent(f.name)}`, { responseType: 'blob' })
            : await axios.get(`/file/${f.id}/download`, { responseType: 'blob' })
        const file = getFile(response, filename)
        files.push(file)
      } catch (e) {
        fileError = true
        console.error(`an error occurred while downloading the file %s for %s with ID %s`, filename, type, requestId, e)
      }
    }

    if (!fileError) downloadZipFile(files, `${secondaryId}.zip`)
    else setDownloadError(true)
  }

  return (
    <FlexColumn>
      <BodyText>Your {type === 'pir' ? pirTerminology.getRequestName() : downloadFileListTypeMap[type]} has been completed!</BodyText>
      <BodyText>Download your files below.</BodyText>
      <FileListContainer>
        <FileList type={type === 'pir' ? 'pir' : 'database'} files={fileList} requestId={requestId} buttonAction="download" />
      </FileListContainer>
      <FlexEndButtonErrorContainer>
        <Button onClick={downloadAll}>Download All</Button>
        {downloadError && <ErrorMessage>There was an error downloading the files. Please try again.</ErrorMessage>}
      </FlexEndButtonErrorContainer>
    </FlexColumn>
  )
}

DownloadFileList.propTypes = {
  type: PropTypes.oneOf(['pir', 'foi']),
  fileList: PropTypes.array,
  requestId: PropTypes.string,
  secondaryId: PropTypes.string.isRequired
}

export default DownloadFileList
